import React from 'react';
import { AppBar, Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { sidebarExtendedState } from '../../../atoms/layout/layout.atom';
import styles from './AdminNavigation.module.scss';
import UserPopover from './UserPopover/UserPopover';
import { useWindowWidth } from '@react-hook/window-size';
import NavigationDrawer from './NavigationDrawer/NavigationDrawer';
import LanguagePopover from './LanguagePopover/LanguagePopover';
import SettingsButton from './SettingsButton/SettingsButton';
import { colors } from '../../../styles/colors';
import { currentUserState } from '../../../atoms/user/user.atom';
import { RoleType } from '../../../domain/Role';
import CompanySelect from './CompanySelect/CompanySelect';
import { navigationComponentConfig } from '../../../../config/navigation/navigation.config';
import Label, { LabelVariant } from '../../../../core/common/Label/Label';

export const AdminNavigation = () => {
  const sidebarExtendedValue = useRecoilValue(sidebarExtendedState);
  const currentUser = useRecoilValue(currentUserState);
  const screenWidth = useWindowWidth();

  return (
    <AppBar
      elevation={4}
      position="fixed"
      color="transparent"
      classes={{
        root: styles.adminNavigationContainer,
      }}
      style={
        screenWidth >= 1200
          ? {
              width: `calc(100% - ${sidebarExtendedValue ? '281px' : '89px'})`,
              backgroundColor: colors.topNavigationBackgroundColor,
            }
          : { backgroundColor: colors.topNavigationBackgroundColor }
      }
    >
      <Box className={styles.adminNavigationInner}>
        <Box className={styles.leftActions}>
          <NavigationDrawer />
          <CompanySelect />
        </Box>
        <Box className={styles.rightActions}>
          {process.env.REACT_APP_ENV && (
            <Label
              variant={LabelVariant.warning_secondary}
              text={process.env.REACT_APP_ENV}
            />
          )}
          {navigationComponentConfig.components}
          {currentUser?.roles.includes(RoleType.SUPER_ADMIN) && (
            <SettingsButton />
          )}
          <LanguagePopover />
          <UserPopover />
        </Box>
      </Box>
    </AppBar>
  );
};

export default AdminNavigation;
